import { render, staticRenderFns } from "./MpItemCJS.vue?vue&type=template&id=3a531828&scoped=true&"
import script from "./MpItemCJS.vue?vue&type=script&lang=js&"
export * from "./MpItemCJS.vue?vue&type=script&lang=js&"
import style1 from "./MpItemCJS.vue?vue&type=style&index=1&id=3a531828&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a531828",
  null
  
)

export default component.exports